import { $$ } from 'utils/dom';

export default class Modal {
  constructor(props) {
    this.modal = props.modal;
    this.modalOpenBtns = props.modalOpenBtns || null;
    this.modalCloseBtns = props.modalCloseBtns;
    this.opener = null;
    this.openClass = props.openClass || 'is-open';
    this.focusIn = props.focusIn || null;
    this.focusOut = props.focusOut || null;
    this.isOpenOnInit = props.isOpenOnInit || false;
    this.focusableElements = $$(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      this.modal
    );
    this.preventCloseOnEsc = props.preventCloseOnEsc || false;
    this.onOpen = typeof props.onOpen === 'function' ? props.onOpen : null;
    this.onClose = typeof props.onClose === 'function' ? props.onClose : null;
    this.modalID = this.modal.getAttribute('id');
  }

  open = openBtn => {
    this.modal.classList.add(this.openClass);
    this.opener = openBtn;
    this.onOpen && this.onOpen(openBtn);
    this.focusIn ? this.focusIn.focus() : this.focusableElements[0].focus();
  };

  close = closeBtn => {
    this.modal.classList.remove(this.openClass);
    this.onClose && this.onClose(closeBtn);
    this.opener ? this.opener.focus() : this.focusOut.focus();
    if (this.isOpenOnInit)
      sessionStorage.setItem('modal-' + this.modalID, true);
  };

  openOnInit = () => {
    if (sessionStorage.getItem('modal-' + this.modalID) !== 'true') this.open();
  };

  closeOnEsc = () => {
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.modal.classList.contains(this.openClass)) {
        this.close();
      }
    });
  };

  trapFocus = e => {
    const firstFocusableElement = this.focusableElements[0];
    const lastFocusableElement =
      this.focusableElements[this.focusableElements.length - 1];

    if (e.key !== 'Tab') {
      return;
    }

    if (e.shiftKey) {
      // if shift + tab was pressed
      if (document.activeElement === firstFocusableElement) {
        // if focused has reached the first focusableElement then focus the last focusableElement
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else {
      // if tab key was pressed
      if (document.activeElement === lastFocusableElement) {
        // if focused has reached the last focusableElement then focus the first focusableElement
        firstFocusableElement.focus();
        e.preventDefault();
      }
    }
  };

  bindEvents = () => {
    this.modalOpenBtns &&
      this.modalOpenBtns.forEach(openBtn => {
        openBtn.addEventListener('click', this.open.bind(this, openBtn));
      });

    this.modalCloseBtns.length &&
      this.modalCloseBtns.forEach(closeBtn => {
        closeBtn.addEventListener('click', this.close.bind(this, closeBtn));
      });

    this.modal.addEventListener('keydown', this.trapFocus);
    !this.preventCloseOnEsc && this.closeOnEsc();
  };

  init = () => {
    if (this.isOpenOnInit) this.openOnInit();
    this.bindEvents();
  };
}
